// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"885":"46855f6fd9e68884","8102":"19685846a13f65c9"}[chunkId] + ".css";
};